const tests_sortby_branch = $('#bundles-promotions .sortby #branch');
const branch_dd_toggler = tests_sortby_branch.find('.dropdown-toggle');
const branch_dd_menu = tests_sortby_branch.find('.dropdown-menu');

(function () {
    // Change direction of OFF CANVAS MENU
    const offCanvasMenus = document.querySelectorAll('.offcanvas');
    if ($('html').attr('dir') === 'rtl' || $('body').hasClass('rtl')) {
        //-------------------------- Arabic
        offCanvasMenus.forEach(menu => {
            $(menu).removeClass('offcanvas-start').addClass('offcanvas-end');
        });
    } else {
        //-------------------------- English
        offCanvasMenus.forEach(menu => {
            $(menu).removeClass('offcanvas-end').addClass('offcanvas-start');
        });
    }
})();

// EVENT HANDLER
// branch selection
branch_dd_menu.find('.dropdown-item').on('click', (e) => {
    e.preventDefault();
    const selected_item = $(e.currentTarget);
    branch_dd_menu.find('.dropdown-item').removeClass('active');
    selected_item.addClass('active');
    branch_dd_toggler.text(selected_item.text());
});